import React, { useState, useContext, useEffect, useRef, useMemo } from "react";
import GeneralContext from "../GeneralContext/GeneralContext";
import axios from "../../api/axios";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";

import TextField from "@mui/material/TextField";
import Chip from "@mui/material/Chip";
import { useParams } from 'react-router-dom';

import Alert from '@mui/material/Alert';
import Autocomplete from '@mui/material/Autocomplete';
import FormControl from "@mui/material/FormControl";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import BreadcrumbStandard from "../GeneralComponents/BreadcrumbStandard";
import dayjs from "dayjs";
import "dayjs/locale/es";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Divider from '@mui/material/Divider';

import PageBody from "../GeneralComponents/PageBody";
import PageButtonBlack from "../GeneralComponents/PageButtonBlack";
import PageBgBlock from "../GeneralComponents/PageBgBlock";
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';

import ModalStandard from "../GeneralComponents/ModalStandard";
import InputFake from "../GeneralComponents/InputFake";
import { useNavigate } from "react-router-dom";
import InputRut from "../GeneralComponents/InputRut";
import InputFile from "../GeneralComponents/InputFile";
import Checkbox from '@mui/material/Checkbox';

import ContingenciasHiddenPreview from "./ContingenciasHiddenPreview";
import HourglassLoader from "../GeneralComponents/HourglassLoader";
import FormControlLabel from '@mui/material/FormControlLabel';
import { DAYS, DEFAULT_ITEMS_CONTINGENCIAS } from "../../Constants/Constants";

import { Button, InputAdornment } from "@mui/material";
import FileDownload from "@mui/icons-material/FileDownload";
import ImageSearchIcon from "@mui/icons-material/ImageSearch";
import { parseBoldText, toSnakeCase } from "../utils/general_utils";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import TuneIcon from "@mui/icons-material/Tune";
import PageButtonSimple from "../GeneralComponents/PageButtonSimple";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton
} from "@mui/material";
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';

const CODIGO_EVENTO_LABELS = {
  "1": "1 - Falla física equipo de datos cliente",
  "2": "2 - Bloqueo equipo de datos cliente",
  "3": "3 - Corte enlace físico (Fibra óptica o cobre)",
  "4": "4 - Corte enlace microondas",
  "5": "5 - Caída plataforma satelital",
  "6": "6 - Caída enlace internacional",
  "7": "7 - Falla nodo de red",
  "8": "8 - Falla red de transporte",
  "9": "9 - Error de configuración firewall",
  "10": "10 - Error de configuración DNS",
  "11": "11 - Error de configuración otro nodo de servicio",
  "12": "12 - Falla de equipo firewall",
  "13": "13 - Falla de equipo DNS",
  "14": "14 - Falla de equipo otro nodo de servicio",
  "15": "15 - Corte de energía EES",
  "16": "16 - Corte suministro público energía",
  "17": "17 - Otro responsabilidad del operador",
  "18": "18 - Otro responsabilidad de terceros",
};

let g_start_date = new Date();
g_start_date.setDate(g_start_date.getDate() - 7);
export default function ContingenciasOverwrite() {

  const { userSesion, setPageTitle, setDrawerHidding } = useContext(GeneralContext);
    const [RBDList, setRBDList] = useState([""]);
    const [rbdLoading, setRbdLoading] = useState(false);

    const [submitConfirm, setSubmitConfirm] = useState(false);
  //const [responseData, setResponseData] = useState(null);
  const [loadingButton, setLoadingButton] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loadingPdf, setLoadingPdf] = useState(false);
  const [eesData, setEesData] = useState(null);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [autoCompleteInput, setAutoCompleteInput] = useState("");
  const autoCompleteRef = useRef(null);
  const datetimeRef = useRef(null);
  const datePRef = useRef(null);
  const timePRef = useRef(null);
  const daysPRef = useRef(null);
  const { id } = useParams();

  const [typeContingencia, setTypeContingencia] = useState("");
  const [titleContingencia, setTitleContingencia] = useState("");
  const [textContingencia, setTextContingencia] = useState("");


      const links = [
    { name: 'Inicio', path: '/home' },
    { name: 'Listado Justificaciones de Indisponibilidad', path: '/contingencias_lista' },
    { name: 'Recrear Justificación de Indisponibilidad', path: '/contingencias_overwrite/'+id },
  ];

  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const navigate = useNavigate();
    const [modalError, setModalError] = useState(false);
    const [modalContent, setModalContent] = useState("");
  const [documentVisible, setDocumentVisible] = useState(true);


    const rutRef = useRef(null);
    const evidenceRef = useRef(null);
    const [evError, setEvError] = useState(false);
    const [errorRut, setErrorRut] = useState(false);
    const [evidence, setEvidence] = useState();

  const contingenciasRef = useRef();
  const [formData, setFormData] = useState({
    name_emisor: userSesion.nombre,
    rut_emisor: userSesion.rut,
    nombre_colegio: "",
    id_operador: "",
    id_zona: "",
    region: "",
    comuna: "",
    operator_name: "",
    rbd: "",
    ees_managers: ["", ""],
    ees_managers_email: ["", ""],
    ees_temporal_manager_list: [""],
    ees_temporal_manager: "",
    ees_temporal_manager_email: "",
    ees_temporal_manager_nombres: "",
    ees_temporal_manager_apellidos: "",
    checked: false,
    contingencia_programada: false,
    programada_descripcion: "",
    programada_inicio_contingencia: dayjs(),
    programada_fin_contingencia: dayjs(),
    programada_hora_inicio: dayjs().hour(0).minute(0),
    programada_hora_termino: dayjs().hour(23).minute(59),
    especifica_fecha_hora_resolucion: dayjs(),
    especifica_fecha_hora_ocurrencia: dayjs(),
    especifica_codigo_evento: "",
    especifica_origen_falla: "",
    especifica_extension_falla: "",
    especifica_descripcion_falla: "",
    days:  DAYS.reduce((acc, dia) => ({ ...acc, [dia]: false }), {}),
    extension: "rbd",
    zonas: [],
  });

  const [autoCompleteInputZonas, setAutoCompleteInputZonas] = useState("");
  const [zonas, setZonas] = useState([]);
  const [zonaData, setZonaData] = useState({});

  function getAllZones(id) {
    const fetchDataZone = async (id) => {
      try {
        const response = await axios.getZonasOperador(id);
        const newZonas = response.data.zonas.map((zona) => ({
          ...zona,
          nombre_zona: `ZONA${String(zona.id_zona).padStart(2, "0")}`,
        }));
        setZonas(newZonas);
      } catch (error) {
        console.error("Error en fetchDataZone:", error);
      }
    };
    fetchDataZone(id);
  }
  const handleDeleteRow = (index) => {
    setFormData((prevState) => ({
      ...prevState,
      zonas: prevState.zonas.filter((_, i) => i !== index),
    }));
  };

  const handleDeleteRbd = (zonaIndex, rbdIndex) => {
    setFormData((prev) => {
      const zonas = [...(prev?.zonas ?? [])];
      const zona = zonas[zonaIndex];
      if (!zona) return prev;

      const rbd_list = Array.isArray(zona.rbd_list) ? [...zona.rbd_list] : [];
      rbd_list.splice(rbdIndex, 1);

      if (rbd_list.length === 0) {
        zonas.splice(zonaIndex, 1);
      } else {
        zonas[zonaIndex] = { ...zona, rbd_list };
      }

      return { ...prev, zonas };
    });
  };

  const handleAddRowZonas = () => {
    if (!autoCompleteInputZonas) return;

    const newZona = zonas.find(
      (zona) => zona.nombre_zona === autoCompleteInputZonas
    );
    if (!newZona) return;

    setFormData((prev) => {
      const prevZonas = Array.isArray(prev?.zonas) ? [...prev.zonas] : [];
      const idx = prevZonas.findIndex((z) => z.id_zona === newZona.id_zona);

      if (idx === -1) {
        return {
          ...prev,
          zonas: [
            ...prevZonas,
            { ...newZona, rbd_list: [...(newZona?.rbd_list ?? [])] },
          ],
        };
      }

      const zonaActual = prevZonas[idx] ?? {};
      const actuales = Array.isArray(zonaActual.rbd_list)
        ? [...zonaActual.rbd_list]
        : [];
      const entrantes = Array.isArray(newZona.rbd_list) ? newZona.rbd_list : [];

      const yaTiene = new Set(actuales.map((x) => String(x)));
      const faltantes = [];
      for (const rbd of entrantes) {
        const k = String(rbd);
        if (!yaTiene.has(k)) {
          yaTiene.add(k);
          faltantes.push(rbd);
        }
      }

      if (faltantes.length === 0) {
        return prev;
      }

      const rbdUnidos = [...actuales, ...faltantes];
      prevZonas[idx] = { ...zonaActual, rbd_list: rbdUnidos };

      return { ...prev, zonas: prevZonas };
    });

    setAutoCompleteInputZonas("");
  };
  const [errorMessages, setErrorMessages] = useState({
    especifica_fecha_hora_ocurrencia: "",
    especifica_fecha_hora_resolucion: "",
  });


    const handleSwitch = (event) => {
      setFormData({ ...formData, ["checked"]: event.target.checked })
  };
      const handleErrorChange = (error) => {
        console.log(error)
        setErrorRut(error);
    };


const createFakePDF = (fileName) => {
    // Crear un Blob vacío con tipo 'application/pdf'
    const fakeBlob = new Blob([''], { type: 'application/pdf' });

    // Convertir el Blob en un archivo (File)
    const fakeFile = new File([fakeBlob], fileName, { type: 'application/pdf' });

    return fakeFile;
};

const validateForm = () => {
  let valid = true;
  const errors = {};

  if (errorRut) {
    rutRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
    return;
  }

  const isProgramada = formData.contingencia_programada;
  const fechaInicioKey = isProgramada ? "programada_inicio_contingencia" : "especifica_fecha_hora_ocurrencia";
  const fechaFinKey = isProgramada ? "programada_fin_contingencia" : "especifica_fecha_hora_resolucion";

  const mensajes = {
    inicioInvalida: `La ${isProgramada ? "fecha de inicio" : "fecha de ocurrencia"} es inválida.`,
    inicioFuturo: `La ${isProgramada ? "fecha de inicio" : "fecha de ocurrencia"} no puede ser una fecha futura.`,
    inicioAntesDelMes: `La ${isProgramada ? "fecha de inicio" : "fecha de ocurrencia"} debe ser posterior al inicio del mes actual.`,
    finInvalida: `La ${isProgramada ? "fecha de término" : "fecha de solución"} es inválida.`,
    finAntesInicio: `La ${isProgramada ? "fecha de término" : "fecha de solución"} debe ser posterior a la ${isProgramada ? "fecha de inicio" : "fecha de ocurrencia"}.`,
    finAntesDelMes: `La ${isProgramada ? "fecha de término" : "fecha de solución"} debe ser posterior al inicio del mes actual.`,
  };

  const startOfMonth = dayjs().subtract(1, "month").startOf("month");

  // Validar fecha de inicio
  if (!formData[fechaInicioKey] || !dayjs(formData[fechaInicioKey]).isValid()) {
    errors[fechaInicioKey] = mensajes.inicioInvalida;
    valid = false;
  } else if (dayjs(formData[fechaInicioKey]).isBefore(startOfMonth)) {
    errors[fechaInicioKey] = mensajes.inicioAntesDelMes;
    valid = false;
  }
  else if (dayjs(formData[fechaInicioKey]).isAfter(dayjs()) && !isProgramada) {
    errors[fechaInicioKey] = mensajes.inicioFuturo;
    valid = false;
  }

  // Validar fecha de fin
  if (!formData[fechaFinKey] || !dayjs(formData[fechaFinKey]).isValid()) {
    errors[fechaFinKey] = mensajes.finInvalida;
    valid = false;
  } else if (dayjs(formData[fechaFinKey]).isBefore(formData[fechaInicioKey])) {
    errors[fechaFinKey] = mensajes.finAntesInicio;
    valid = false;
  } else if (dayjs(formData[fechaFinKey]).isBefore(startOfMonth)) {
    errors[fechaFinKey] = mensajes.finAntesDelMes;
    valid = false;
  } else if (dayjs(formData[fechaFinKey]).isAfter(dayjs()) && !isProgramada) {
    errors[fechaFinKey] = mensajes.inicioFuturo;
    valid = false;
  }
  if(isProgramada && dayjs(formData["programada_hora_inicio"]).isAfter(formData["programada_hora_termino"])){
    errors["programada_hora_termino"] = "La hora de termino debe ser posterior a la de inicio";
    valid = false;
    timePRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
  } else if (isProgramada && !Object.values(formData.days).some((value) => value)) {
    errors["days"] = "Debe seleccionar al menos un día";
    daysPRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
    valid = false;

} else if (!valid) {
    if (isProgramada) {
      datePRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
    } else {
      datetimeRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }

  setErrorMessages(errors);
  return valid;
};

    const setFile = (archivo) => {
      setEvError(!archivo && !formData.contingencia_programada ? true : false);
    setEvidence((prevData) => ({
      ...prevData,
      archivo,
    }));
  };
const fetchData = (query) => {
    setLoading(true);

    axios
        .getContingencia(id)
        .then((response) => {
            const datos = response.data.datos || {};

            const parseTime = (timeString) => {
                if (!timeString) return "";
                const [hours, minutes, seconds] = timeString.split(":").map(Number);
                return dayjs().set("hour", hours).set("minute", minutes).set("second", seconds);
            };

            setFormData({
                ...datos,
                especifica_fecha_hora_ocurrencia: dayjs(datos["especifica_fecha_hora_ocurrencia"] || ""),
                especifica_fecha_hora_resolucion: dayjs(datos["especifica_fecha_hora_resolucion"] || ""),
                programada_inicio_contingencia: dayjs(datos["programada_inicio_contingencia"] || ""),
                programada_fin_contingencia: dayjs(datos["programada_fin_contingencia"] || ""),
                programada_hora_inicio: parseTime(datos["programada_hora_inicio"]),
                programada_hora_termino: parseTime(datos["programada_hora_termino"]),
                ees_managers_email: response.data.ees_managers_email ? response.data.ees_managers_email : ["", ""],
                estado: response.data.estado,
                extension: datos["extension"] ? datos["extension"] : "rbd",
            });

            const tipo = response.data.tipo_contingencia;
            const item =
                DEFAULT_ITEMS_CONTINGENCIAS.find(
                    (i) =>
                        i.type === tipo &&
                        (i.type !== "ESPECIFICA" ||
                            i.subtype === datos["especifica_origen_falla"])
                ) || DEFAULT_ITEMS_CONTINGENCIAS.find((i) => i.type === tipo);

            setTypeContingencia(tipo);
            setTitleContingencia(item?.title ?? "LEVANTAMIENTO DE JUSTIFICACIÓN DE INDISPONIBILIDAD");
            setTextContingencia(item?.description ?? "");

            setPdfUrl(response.data.ruta_url);

            if (response.data.especifica_evidencia_url) {
                setFile(createFakePDF(response.data.especifica_evidencia_url.split("/").pop()));
            }

            getAllZones(response.data.id_operador);
        })
        .catch((error) => {
            console.error("Error al obtener los datos:", error);
            setDocumentVisible(false);
        })
        .finally(() => {
            setLoading(false);
        });
};




function getEes() {
    if (autoCompleteInput !== "") {
        const rbd_temp = autoCompleteInput;
        axios.getEesData(rbd_temp, "1")
            .then((response) => {
                const tempRep =
                    response.data.nombres_representantes.length === 1
                        ? [response.data.nombres_representantes[0], "Sin representante"]
                        : response.data.nombres_representantes;

                setFormData((prevFormData) => ({
                    ...prevFormData,
                    nombre_colegio: response.data.nombre_colegio,
                    ees_managers: tempRep.length > 0 ? tempRep : ["Sin representante", "Sin representante"],
                    ees_temporal_manager_list:
                        response.data.nombres_representantes_temporales.length > 0
                            ? response.data.nombres_representantes_temporales
                            : ["Sin representante"],
                    id_zona: response.data.id_zona+""
                }));
                setError(false);
                setErrorMsg("");
            })
            .catch((error) => {
                console.error("Error al obtener datos del EES:", error);

                setFormData((prevFormData) => ({
                    ...prevFormData,
                    nombre_colegio: "Colegio no encontrado",
                    ees_managers: ["Colegio no encontrado", "Colegio no encontrado"],
                    ees_temporal_manager_list: ["Sin representante"],
                    id_zona: ""
                }));

                setError(true);
                setErrorMsg("Colegio no encontrado");
            });
    }
}

  const save = async (event) => {
    event.preventDefault();
    if (loadingButton) return;
    setLoadingButton(true);

    if (!submitConfirm) {
        setSubmitConfirm(!submitConfirm);
        setLoadingButton(false);
        return;
    }

    if (!evidence && !formData.contingencia_programada){
        setEvError(!evidence && !formData.contingencia_programada ? true : false);
        evidenceRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
        setLoadingButton(false);
        return;
    }
    if (error) {
      autoCompleteRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
        setLoadingButton(false);
      return;
    }

    setLoading(true);

    if (validateForm()) {
      handleDownloadPdf();
    }else{
      setLoading(false);
      setLoadingButton(false);
    }
  };

  const handleDownloadPdf = () => {

    const element = contingenciasRef.current;
    setLoadingPdf(true);

    setTimeout(() => {
    const element = contingenciasRef.current;

    html2canvas(element, { scale: 2 })
      .then((canvas) => {
        setLoading(true);
        const imageData = canvas.toDataURL('image/jpeg', 1);

        const pdfWidth = 210;
        const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
        const pdf = new jsPDF('p', 'mm', [pdfWidth, pdfHeight + 7]);

        pdf.setFillColor(255, 255, 255);
        pdf.rect(0, 0, pdfWidth, pdfHeight + 140, 'F');
        pdf.addImage(imageData, 'JPEG', 0, 0, pdfWidth, pdfHeight);

        const pdfBlob = pdf.output('blob');

            const form = new FormData();
            const localFormData = {
                ...formData,
                rbd: autoCompleteInput ? autoCompleteInput : "",
                especifica_fecha_hora_ocurrencia: formData["especifica_fecha_hora_ocurrencia"]
                    ? formData["especifica_fecha_hora_ocurrencia"].locale('es').format('YYYY/MM/DD HH:mm:ss').toString()
                    : null,
                especifica_fecha_hora_resolucion: formData["especifica_fecha_hora_resolucion"]
                    ? formData["especifica_fecha_hora_resolucion"].locale('es').format('YYYY/MM/DD HH:mm:ss').toString()
                    : null,
                programada_inicio_contingencia: formData["programada_inicio_contingencia"]
                    ? formData["programada_inicio_contingencia"].locale('es').format('YYYY/MM/DD').toString()
                    : null,
                programada_fin_contingencia: formData["programada_fin_contingencia"]
                    ? formData["programada_fin_contingencia"].locale('es').format('YYYY/MM/DD').toString()
                    : null,
                programada_hora_inicio: formData["programada_hora_inicio"]
                    ? formData["programada_hora_inicio"].locale('es').format('HH:mm:ss').toString()
                    : null,
                programada_hora_termino: formData["programada_hora_termino"]
                    ? formData["programada_hora_termino"].locale('es').format('HH:mm:ss').toString()
                    : null,
                evidence_list: evidence && evidence.archivo ? [evidence.archivo] : [],
            };

            form.append("data", JSON.stringify(localFormData));

            for (let i = 0; i < localFormData["evidence_list"].length; i++) {
                form.append("evidence", localFormData["evidence_list"][i]);
            }

            form.append("file", pdfBlob, "temp.pdf");

            axios.overwriteFilesContingencias(form, id)
                .then((response) => {
                    setLoading(false);
                    //setSubmitConfirm(!submitConfirm)
                    setModalError(false);
                    setModalContent("Documento modificado");
                    setOpen(true);
                })
                .catch((error) => {
                    setModalError(true);
                    setModalError("La modificación del documento falló");
                    setLoading(false);

                })
        setLoadingPdf(false);
        setSubmitConfirm(false);
        setLoadingButton(false);
      })
      .catch((error) => {
        console.error('Error generando el PDF:', error);
        setLoadingPdf(false);
        setLoading(false);
        setSubmitConfirm(false);
        setLoadingButton(false);
      });
  }, 0);

};

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      days: {
        ...prevFormData.days,
        [name]: checked,
      },
    }));
    setErrorMessages((prevErrorMessages) => ({
      ...prevErrorMessages,
      days: null,
    }));

  };


  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

      useEffect(() => {
    fetchData("");
  }, []);

      useEffect(() => {
        fetchData()
        setDrawerHidding(false)
    }, [setPageTitle, setDrawerHidding]);

  const codigoOptions = useMemo(() => {
    let options = [];
    if (formData.especifica_origen_falla === "Falla interna al adjudicatario") {
      options = [
        { value: "15", label: CODIGO_EVENTO_LABELS["15"] },
        { value: "18", label: CODIGO_EVENTO_LABELS["18"] },
      ];
    } else if (
      formData.especifica_origen_falla === "Falla externa al adjudicatario"
    ) {
      options = [
        { value: "16", label: CODIGO_EVENTO_LABELS["16"] },
        { value: "18", label: CODIGO_EVENTO_LABELS["18"] },
      ];
    }
    // Contingencias antiguas pueden tener códigos que ya no se ofrecen:
    // se agregan como opción para que el valor guardado siga visible.
    const stored = formData.especifica_codigo_evento;
    if (stored && !options.some((opt) => opt.value === stored)) {
      options = [
        ...options,
        { value: stored, label: CODIGO_EVENTO_LABELS[stored] ?? stored },
      ];
    }
    return options;
  }, [formData.especifica_origen_falla, formData.especifica_codigo_evento]);

  const repCount = Math.max(
    formData?.ees_managers?.length ?? 0,
    formData?.ees_managers_email?.length ?? 0,
    1
  );

  return (
    <>
    <PageBody>
    <BreadcrumbStandard links={links} />
    <PageBgBlock >
    <Grid container spacing={2}>
                  <Grid size={8}>
                    <TextField
                      disabled
                      size="small"
                      variant="outlined"
                      placeholder="Subir evidencia (formato PDF)"
                      value={pdfUrl}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment
                            position="start"
                            sx={{ marginLeft: "10px" }}
                          >
                            <ImageSearchIcon sx={{ color: "black" }} />
                          </InputAdornment>
                        ),
                        readOnly: true,
                      }}
                      sx={{ width: "100%", maxWidth: "100%" }}
                      readOnly
                    />
                  </Grid>
                  <Grid size={4}>
                    <Button
                      fullWidth
                      variant="text"
                      disabled={
                        formData.evidence && formData.evidence.length > 0
                          ? false
                          : true
                      }
                      color="primary"
                      onClick={() =>
                        window.open(pdfUrl, "_blank")
                      }
                      startIcon={<FileDownload />}
                    >
                      Ver documento actual
                    </Button>
                  </Grid>
                </Grid>
      </PageBgBlock>
      <Box sx={{margin: 5}}></Box>
      <PageBgBlock pad="0" >
      { loading ? (<HourglassLoader/>) : (<><Box sx={{ paddingLeft: "9rem", paddingRight: "9rem", paddingTop: "2rem"}}>
        <Typography
          variant="h1"
          align="center"
          sx={{ marginBottom: "0.24rem" }}
        >
          {titleContingencia}
        </Typography>
        <Stack alignItems="left" justifyContent="center" spacing={2} >
        <Box justifyContent="center" sx={{display: 'flex', margin: '0.2rem!important'}}>
        <Typography
            variant="small"
            color="inherit"
            sx={{ textAlign: "center", justifyContent: "center", paddingY: "0", marginTop: '0'}}
        >
             N° folio: <Typography variant="small" sx={{paddingLeft:'1rem', marginTop: '0', color: '#FFF'}}>{String('').padStart(8, '0')}</Typography>
        </Typography>
        </Box>

        <Box
          justifyContent="center"
          sx={{ maxWidth: "100%", margin: "0 auto", display: "flex" }}
        >
          <Typography
            variant="body"
            align="center"
            sx={{ marginBottom: "2rem" }}
          >
            {parseBoldText(textContingencia)}
          </Typography>
        </Box>
        </Stack>

        <form onSubmit={save} id="contingencia">
          <Stack spacing={4} sx={{ marginBottom: "2rem" }}>
            <Typography
              variant="h3"
              color="inherit"
              noWrap
              sx={{ flexGrow: 1 }}
            >
              DATOS DEL EMISOR
            </Typography>

            <Grid container spacing={2}>
              <Grid size={6}>
                <FormControl fullWidth variant="outlined">
                  <TextField
                    test_id={toSnakeCase("rut_emisor")}
                    disabled
                    required
                    name="rut"
                    label="Rut Operador Administrador"
                    size="small"
                    value={formData.rut_emisor}
                    onChange={handleInputChange}
                  />
                </FormControl>
              </Grid>
              <Grid size={6}>
                <FormControl fullWidth variant="outlined">
                  <TextField
                    test_id={toSnakeCase("name_emisor")}
                    disabled
                    required
                    name="nombre"
                    label="Nombre y Apellido"
                    size="small"
                    value={formData.name_emisor}
                    onChange={handleInputChange}
                  />
                </FormControl>
              </Grid>
            </Grid>

            <Typography
              variant="h3"
              color="inherit"
              noWrap
              sx={{ flexGrow: 1 }}
            >
              DATOS DEL OPERADOR
            </Typography>

            <Grid container spacing={2}>
              <Grid size={6}>
                <FormControl fullWidth variant="outlined">
                  <TextField
                    test_id={toSnakeCase("id_operador")}
                    disabled
                    required
                    name="id_operador"
                    label="ID Operador"
                    size="small"
                    value={formData.id_operador}
                    onChange={handleInputChange}
                  />
                </FormControl>
              </Grid>
              <Grid size={6}>
                <FormControl fullWidth variant="outlined">
                  <TextField
                    test_id={toSnakeCase("operator_name")}
                    disabled
                    required
                    name="operator_name"
                    label="Nombre Operador"
                    size="small"
                    value={formData.operator_name}
                    onChange={handleInputChange}
                  />
                </FormControl>
              </Grid>
            </Grid>

            <Typography
              variant="h3"
              color="inherit"
              noWrap
              sx={{ flexGrow: 1 }}
            >
              DATOS BASE DE JUSTIFICACIÓN DE INDISPONIBILIDAD
            </Typography>

            <Grid container spacing={2}>
              <Grid size={12}>
                <FormControl sx={{ width: "100%" }} size="small">
                  <InputLabel
                    id="especifica_origen_falla-label"
                    sx={{ backgroundColor: "#fff" }}
                  >
                    Origen del corte
                  </InputLabel>
                  <Select
                    test_id={toSnakeCase("especifica_origen_falla")}
                    disabled
                    labelId="especifica_origen_falla-label"
                    id="especifica_origen_falla"
                    value={formData.especifica_origen_falla}
                    label="Origen del corte"
                    size="small"
                    sx={{ width: "100%" }}
                    onChange={(event) =>
                      setFormData({
                        ...formData,
                        especifica_origen_falla: event.target.value,
                      })
                    }
                  >
                    <MenuItem
                      test_id={toSnakeCase("menu_especifica_origen_falla_0")}
                      value={"Falla interna al adjudicatario"}
                    >
                      Evento interno al establecimiento
                    </MenuItem>
                    <MenuItem
                      test_id={toSnakeCase("menu_especifica_origen_falla_1")}
                      value={"Falla externa al adjudicatario"}
                    >
                      Evento externo al establecimiento
                    </MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              {typeContingencia !== "PROGRAMADA" && (
                <Grid size={12}>
                  <FormControl fullWidth size="small">
                    <InputLabel
                      id="especifica_codigo_evento-label"
                      sx={{ backgroundColor: "#fff", px: 0.5 }}
                    >
                      Código de evento
                    </InputLabel>
                    <Select
                      test_id={toSnakeCase("especifica_codigo_evento")}
                      required
                      disabled={formData.especifica_origen_falla === ""}
                      labelId="especifica_codigo_evento-label"
                      id="especifica_codigo_evento"
                      value={formData.especifica_codigo_evento}
                      label="Código de evento"
                      size="small"
                      onChange={(event) =>
                        setFormData({
                          ...formData,
                          especifica_codigo_evento: event.target.value,
                        })
                      }
                    >
                      {codigoOptions.map((opt) => (
                        <MenuItem
                          test_id={toSnakeCase(
                            "menu_especifica_codigo_evento_" + opt.value
                          )}
                          key={opt.value}
                          value={opt.value}
                        >
                          {opt.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              )}
            </Grid>

            {typeContingencia === "ZONAL" && (
              <>
                <Typography
                  variant="h3"
                  color="inherit"
                  noWrap
                  sx={{ flexGrow: 1 }}
                >
                  DATOS DE LA ZONA
                </Typography>

                <Grid container spacing={2}>
                  <Grid size={9}>
                    <FormControl sx={{ minWidth: "100%" }}>
                      <Autocomplete
                        test_id={toSnakeCase("Autocomplete_zona")}
                        value={
                          zonas.find(
                            (zona) =>
                              zona.nombre_zona === autoCompleteInputZonas
                          ) || null
                        }
                        onChange={(event, newValue) => {
                          setAutoCompleteInputZonas(
                            newValue ? newValue.nombre_zona : ""
                          );
                          if (newValue) {
                            setZonaData(newValue);
                          }
                        }}
                        disablePortal
                        loading={rbdLoading}
                        loadingText="Cargando..."
                        options={zonas || []}
                        getOptionLabel={(option) => option?.nombre_zona || ""}
                        isOptionEqualToValue={(option, value) =>
                          option?.id_zona === value?.id_zona
                        }
                        size="small"
                        autoComplete
                        renderInput={(params) => (
                          <TextField
                            test_id={toSnakeCase("Zona")}
                            {...params}
                            error={error}
                            helperText={errorMsg}
                            label="Zona"
                            placeholder="Buscar zona"
                            InputProps={{
                              ...params.InputProps,
                              startAdornment: (
                                <>
                                  {params.InputProps.startAdornment}
                                  <TuneIcon />
                                </>
                              ),
                            }}
                          />
                        )}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item size={3}>
                    <PageButtonSimple
                      pad=".5rem"
                      width="auto"
                      onClick={handleAddRowZonas}
                      startIcon={<AddCircleOutlineOutlinedIcon />}
                      disabled={!autoCompleteInputZonas || rbdLoading}
                    >
                      Agregar a la lista
                    </PageButtonSimple>
                  </Grid>

                  <Grid size={12}>
                    <TableContainer component={Paper} sx={{ mb: 2, mt: 2 }}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell sx={{ width: "80px" }}>
                              <IconButton
                                test_id={toSnakeCase("delete")}
                                onClick={() =>
                                  setFormData((prevState) => ({
                                    ...prevState,
                                    zonas: [],
                                  }))
                                }
                              >
                                <RemoveCircleOutlineIcon />
                              </IconButton>
                            </TableCell>
                            <TableCell sx={{ width: "80px" }}>
                              Id Zona
                            </TableCell>
                            <TableCell>RBDs</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {formData.zonas && formData.zonas.length > 0 ? (
                            formData.zonas.map((zona, index) => (
                              <TableRow key={index}>
                                <TableCell>
                                  <IconButton
                                    test_id={toSnakeCase("delete_" + index)}
                                    onClick={() => handleDeleteRow(index)}
                                  >
                                    <RemoveCircleOutlineIcon />
                                  </IconButton>
                                </TableCell>
                                <TableCell sx={{ verticalAlign: "middle" }}>
                                  {zona.id_zona}
                                </TableCell>
                                <TableCell sx={{ verticalAlign: "middle" }}>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexWrap: "wrap",
                                      gap: 0.5,
                                    }}
                                  >
                                    {Array.isArray(zona.rbd_list) &&
                                    zona.rbd_list.length > 0
                                      ? zona.rbd_list.map((rbd, ri) => (
                                          <Chip
                                            key={`${zona.id_zona}-${ri}`}
                                            label={String(rbd)}
                                            size="small"
                                            variant="outlined"
                                            onDelete={() =>
                                              handleDeleteRbd(index, ri)
                                            }
                                            test_id={toSnakeCase(
                                              `delete_rbd_${index}_${ri}`
                                            )}
                                          />
                                        ))
                                      : null}
                                  </Box>
                                </TableCell>
                              </TableRow>
                            ))
                          ) : (
                            <TableRow>
                              <TableCell colSpan={4} align="center">
                                No hay zonas agregadas
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                </Grid>
              </>
            )}

            {(typeContingencia === "PROGRAMADA" ||
              typeContingencia === "ESPECIFICA") && (
              <>
                <Typography
                  variant="h3"
                  color="inherit"
                  noWrap
                  sx={{ flexGrow: 1 }}
                >
                  DATOS DEL RBD
                </Typography>
                <Grid container spacing={2}>
                  <Grid size={6}>
                    <Box ref={autoCompleteRef}>
                      <TextField
                        test_id={toSnakeCase("rbd")}
                        disabled
                        id="outlined-required"
                        label="RBD"
                        size="small"
                        sx={{ width: "100%" }}
                        value={formData.rbd}
                      />
                    </Box>
                  </Grid>

                  <Grid size={6}>
                    <FormControl fullWidth variant="outlined">
                      <TextField
                        test_id={toSnakeCase("id_zona")}
                        label="ID Zona"
                        size="small"
                        disabled
                        value={formData.id_zona}
                        sx={{ width: "100%" }}
                      />
                    </FormControl>
                  </Grid>

                  <Grid size={6}>
                    <FormControl fullWidth variant="outlined">
                      <TextField
                        test_id={toSnakeCase("region")}
                        label="Región"
                        size="small"
                        disabled
                        value={formData.region ?? ""}
                        sx={{ width: "100%" }}
                      />
                    </FormControl>
                  </Grid>

                  <Grid size={6}>
                    <FormControl fullWidth variant="outlined">
                      <TextField
                        test_id={toSnakeCase("comuna")}
                        label="Comuna"
                        size="small"
                        disabled
                        value={formData.comuna ?? ""}
                        sx={{ width: "100%" }}
                      />
                    </FormControl>
                  </Grid>

                  <Grid size={12}>
                    <FormControl fullWidth variant="outlined">
                      <TextField
                        test_id={toSnakeCase("nombre_colegio")}
                        id="outlined"
                        label="Nombre del Colegio"
                        size="small"
                        disabled
                        value={formData.nombre_colegio}
                        sx={{ width: "100%" }}
                      />
                    </FormControl>
                  </Grid>
                  {Array.from({ length: repCount }).map((_, i) => (
                    <React.Fragment key={i}>
                      <Grid size={6}>
                        <TextField
                          test_id={toSnakeCase(`ees_managers_${i}`)}
                          label={`Representante del establecimiento ${i + 1}`}
                          size="small"
                          disabled
                          value={formData?.ees_managers?.[i] ?? ""}
                          sx={{ width: "100%" }}
                        />
                      </Grid>

                      <Grid size={6}>
                        <TextField
                          test_id={toSnakeCase(`ees_managers_email_${i}`)}
                          label={`Email Representante del establecimiento ${
                            i + 1
                          }`}
                          size="small"
                          disabled
                          value={formData?.ees_managers_email?.[i] ?? ""}
                          sx={{ width: "100%" }}
                        />
                      </Grid>
                    </React.Fragment>
                  ))}
                </Grid>

                {formData.especifica_origen_falla ===
                  "Falla interna al adjudicatario" && (
                  <Grid container spacing={2}>
                    <Grid sx={{ width: "100%", marginY: 2 }} size={12}>
                      <Box ref={rutRef}>
                        <InputRut
                          error={errorRut}
                          errorRut={handleErrorChange}
                          checked={formData.checked}
                          rut={formData.ees_temporal_manager}
                          email={formData.ees_temporal_manager_email}
                          nombre_temp={formData.ees_temporal_manager_nombres}
                          apellido_temp={
                            formData.ees_temporal_manager_apellidos
                          }
                          handleSwitch={handleSwitch}
                          handleRut={(newValue) =>
                            setFormData({
                              ...formData,
                              ["ees_temporal_manager"]: newValue,
                            })
                          }
                          handleEmail={(newValue) =>
                            setFormData({
                              ...formData,
                              ["ees_temporal_manager_email"]: newValue,
                            })
                          }
                          handleNombre={(newValue) =>
                            setFormData({
                              ...formData,
                              ["ees_temporal_manager_nombres"]: newValue,
                            })
                          }
                          handleApellido={(newValue) =>
                            setFormData({
                              ...formData,
                              ["ees_temporal_manager_apellidos"]: newValue,
                            })
                          }
                          margin="0"
                        ></InputRut>
                      </Box>
                    </Grid>
                  </Grid>
                )}
              </>
            )}

            <Typography variant="h3" color="inherit" noWrap sx={{}}>
              DETALLE DE LA JUSTIFICACIÓN DE INDISPONIBILIDAD
            </Typography>

            {typeContingencia === "PROGRAMADA" && (
              <FormControl sx={{ width: "100%", spacing: 2 }}>
                <Grid container spacing={2}>
                  <Grid size={12}>
                    <FormControl sx={{ width: "100%", maxWidth: "100%" }}>
                      <TextField
                        test_id={toSnakeCase("programada_descripcion")}
                        required
                        multiline
                        minRows={4}
                        maxRows={30}
                        id="outlined-required"
                        label="Descripción de justificación de indisponibilidad"
                        placeholder="Descripción de justificación de indisponibilidad"
                        size="small"
                        value={formData.programada_descripcion}
                        onChange={(event) =>
                          setFormData({
                            ...formData,
                            programada_descripcion: event.target.value,
                          })
                        }
                      />
                    </FormControl>
                  </Grid>

                  <Grid size={12}>
                    <Typography size="body">
                      Rango horario de ocurrencia
                    </Typography>
                    <Divider></Divider>
                  </Grid>

                  <Grid size={6} ref={timePRef}>
                    <LocalizationProvider
                      dateAdapter={AdapterDayjs}
                      adapterLocale="es"
                    >
                      <TimePicker
                        test_id={toSnakeCase("programada_hora_inicio")}
                        sx={{ width: "100%" }}
                        label="Hora de inicio"
                        value={formData.programada_hora_inicio}
                        onChange={(newValue) =>
                          setFormData({
                            ...formData,
                            programada_hora_inicio: newValue,
                          })
                        }
                        minTime={dayjs().startOf("day")}
                        minutesStep={1}
                        slotProps={{
                          textField: {
                            required: true,
                            size: "small",
                            helperText: errorMessages.programada_hora_inicio,
                            error: !!errorMessages.programada_hora_inicio,
                          },
                        }}
                      />
                    </LocalizationProvider>
                  </Grid>

                  <Grid size={6}>
                    <LocalizationProvider
                      dateAdapter={AdapterDayjs}
                      adapterLocale="es"
                    >
                      <TimePicker
                        test_id={toSnakeCase("programada_hora_termino")}
                        sx={{ width: "100%" }}
                        label="Hora de término"
                        value={formData.programada_hora_termino}
                        minutesStep={1}
                        onChange={(newValue) =>
                          setFormData({
                            ...formData,
                            programada_hora_termino: newValue,
                          })
                        }
                        minTime={formData.programada_hora_inicio}
                        slotProps={{
                          textField: {
                            required: true,
                            size: "small",
                            helperText: errorMessages.programada_hora_termino,
                            error: !!errorMessages.programada_hora_termino,
                          },
                        }}
                      />
                    </LocalizationProvider>
                  </Grid>

                  <Grid size={12}>
                    <Typography size="body">
                      Repetición de la ocurrencia
                    </Typography>
                    <Divider></Divider>
                  </Grid>

                  <Grid size={12} ref={daysPRef}>
                    <Grid container spacing={2} columns={14}>
                      {DAYS.map((dia) => (
                        <Grid size={2} key={dia}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                test_id={toSnakeCase(dia)}
                                checked={formData.days[dia]}
                                onChange={handleCheckboxChange}
                                name={dia}
                              />
                            }
                            label={dia}
                          />
                        </Grid>
                      ))}
                    </Grid>

                    {!!errorMessages.days && (
                      <Grid size={12}>
                        <Typography color="error" size="small">
                          {errorMessages.days}
                        </Typography>
                      </Grid>
                    )}
                  </Grid>

                  <Grid size={12}>
                    <Typography size="body">
                      Periodo que debe durar la justificación de indisponibilidad programada
                    </Typography>
                    <Divider></Divider>
                  </Grid>

                  <Grid size={6} ref={datePRef}>
                    <LocalizationProvider
                      dateAdapter={AdapterDayjs}
                      adapterLocale={"es"}
                    >
                      <DatePicker
                        test_id={toSnakeCase("programada_inicio_contingencia")}
                        sx={{ width: "100%" }}
                        label="Fecha de inicio periodo"
                        value={formData.programada_inicio_contingencia}
                        onChange={(newValue) =>
                          setFormData({
                            ...formData,
                            programada_inicio_contingencia: newValue,
                          })
                        }
                        minDate={dayjs()
                          .subtract(1, "month")
                          .startOf("month")}
                        slotProps={{
                          textField: {
                            required: true,
                            size: "small",
                            helperText:
                              errorMessages.programada_inicio_contingencia,
                            error:
                              !!errorMessages.programada_inicio_contingencia,
                          },
                        }}
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Grid size={6}>
                    <LocalizationProvider
                      dateAdapter={AdapterDayjs}
                      adapterLocale={"es"}
                    >
                      <DatePicker
                        test_id={toSnakeCase("programada_fin_contingencia")}
                        sx={{ width: "100%" }}
                        label="Fecha de término periodo"
                        value={formData.programada_fin_contingencia}
                        onChange={(newValue) =>
                          setFormData({
                            ...formData,
                            programada_fin_contingencia: newValue,
                          })
                        }
                        minDate={formData.programada_inicio_contingencia}
                        slotProps={{
                          textField: {
                            required: true,
                            size: "small",
                            helperText:
                              errorMessages.programada_fin_contingencia,
                            error: !!errorMessages.programada_fin_contingencia,
                          },
                        }}
                      />
                    </LocalizationProvider>
                  </Grid>
                </Grid>
              </FormControl>
            )}

            {(typeContingencia === "ZONAL" ||
              typeContingencia === "ESPECIFICA") && (
              <>
                <Grid container spacing={2} ref={datetimeRef}>
                  <Grid size={6}>
                    <LocalizationProvider
                      dateAdapter={AdapterDayjs}
                      adapterLocale={"es"}
                    >
                      <DateTimePicker
                        test_id={toSnakeCase("especifica_fecha_hora_ocurrencia")}
                        sx={{ width: "100%" }}
                        label="Fecha y hora de ocurrencia"
                        value={formData.especifica_fecha_hora_ocurrencia}
                        onChange={(newValue) =>
                          setFormData({
                            ...formData,
                            especifica_fecha_hora_ocurrencia: newValue,
                          })
                        }
                        minDate={dayjs().subtract(1, "month").startOf("month")}
                        slotProps={{
                          textField: {
                            required: true,
                            size: "small",
                            helperText:
                              errorMessages.especifica_fecha_hora_ocurrencia,
                            error:
                              !!errorMessages.especifica_fecha_hora_ocurrencia,
                          },
                        }}
                        disableFuture
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Grid size={6}>
                    <LocalizationProvider
                      dateAdapter={AdapterDayjs}
                      adapterLocale={"es"}
                    >
                      <DateTimePicker
                        test_id={toSnakeCase("especifica_fecha_hora_resolucion")}
                        sx={{ width: "100%" }}
                        label="Fecha y hora de resolución"
                        value={formData.especifica_fecha_hora_resolucion}
                        onChange={(newValue) =>
                          setFormData({
                            ...formData,
                            especifica_fecha_hora_resolucion: newValue,
                          })
                        }
                        minDate={formData.especifica_fecha_hora_ocurrencia}
                        slotProps={{
                          textField: {
                            required: true,
                            size: "small",
                            helperText:
                              errorMessages.especifica_fecha_hora_resolucion,
                            error:
                              !!errorMessages.especifica_fecha_hora_resolucion,
                          },
                        }}
                        disableFuture
                      />
                    </LocalizationProvider>
                  </Grid>
                </Grid>

                {!loadingPdf ? (
                  <>
                    <FormControl sx={{ width: "100%", maxWidth: "100%" }}>
                      <TextField
                        test_id={toSnakeCase("especifica_descripcion_falla")}
                        required={!formData.contingencia_programada}
                        multiline
                        minRows={4}
                        maxRows={30}
                        id="outlined-required"
                        label="Descripción de falla"
                        placeholder="Descripción de falla"
                        size="small"
                        value={formData.especifica_descripcion_falla}
                        onChange={(event) =>
                          setFormData({
                            ...formData,
                            especifica_descripcion_falla: event.target.value,
                          })
                        }
                      />
                    </FormControl>
                  </>
                ) : (
                  <>
                    <InputFake
                      value={formData.especifica_descripcion_falla}
                    ></InputFake>
                  </>
                )}
              </>
            )}

            {typeContingencia !== "PROGRAMADA" && (
              <Box ref={evidenceRef}>
                <InputFile
                  onFileSelect={setFile}
                  initialFile={evidence}
                  fileType="pdf"
                  placeholder="Subir evidencia (formato PDF)"
                />
                <Typography
                  variant="small"
                  align="left"
                  sx={{
                    marginBottom: "5px",
                    color: evError ? "red" : "#111",
                  }}
                >
                  {evError ? "Debe adjuntar evidencia" : ""}
                </Typography>

                <Typography
                  variant="small"
                  align="left"
                  sx={{
                    mt: "5px",
                    display: "block",
                  }}
                >
                  *Atención: Se recomienda que las fotografías dentro de la
                  evidencia vengan georeferenciadas (marca de fecha y lugar en
                  la que se tomó) esto será validado por SUBTEL y no por la
                  plataforma SAGEC.
                </Typography>
              </Box>
            )}
          </Stack>

        </form>
          </Box>
          <Stack sx={{paddingLeft: "9rem", paddingRight: "9rem", paddingBottom: "3rem" }}>
          <Grid >
          {submitConfirm ?
                                <Grid display="flex" justifyContent="center" alignItems="center" size={12} sx={{paddingBottom: "3rem"}} >
                                    <Alert icon={false} variant="filled" severity="warning" sx={{ display: "flex", justifyContent: "center", '& .MuiAlert-message': { textAlign: "center", width: "inherit" } }}>
                                        <Typography
                                            variant="body"
                                            color="inherit"
                                            sx={{ textAlign: "center" }}
                                        >
                                            Revise que todos los campos tienen la información correcta antes de enviar el levantamiento de Justificación de Indisponibilidad, al clickear “Recrear documento” el documento queda firmado por el operador.
                                        </Typography>
                                    </Alert>
                                </Grid>
                                :
                                ""
                            }
          </Grid>
          <PageButtonBlack form="contingencia" loading={loadingButton}> Recrear documento</PageButtonBlack>
          </Stack>

          </>)
            }  <ModalStandard open={open} error={modalError} title={modalContent} btnText="Volver a listado" onClick={() => navigate("/contingencias_lista")} onClose={handleClose}></ModalStandard>

      </PageBgBlock>
    </PageBody>
    { loadingPdf ?
            (
            <Box sx={{maxWidth: "100%", overflow: "hidden", position: "absolute", width: "1200px", height:"0"}}>
            <Box ref={contingenciasRef}  sx={{padding: "12px"}}>
            <ContingenciasHiddenPreview formData={formData} textContingencia={textContingencia} typeContingencia={typeContingencia} evidence={evidence}></ContingenciasHiddenPreview>
            </Box>
            </Box>) : null}
    </>
  );
}
